import { useState, type ReactNode } from "react";
import MetierDialog from "./MetierDialog";
import type { Metier } from "models";
import { Grid, IconButton, Tooltip } from "@mui/material";
import ConfirmationDialog from "components/atoms/ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

interface MetierActionsProps {
  metier: Metier;
  onMetierChanged: (metier: Metier) => void;
  onMetierDelete: (metier: Metier) => void;
}

function MetierActions({
  metier,
  onMetierChanged,
  onMetierDelete,
}: Readonly<MetierActionsProps>): ReactNode {
  const [isModificationDialogOpen, setIsModificationDialogOpen] = useState(false);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

  return (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Tooltip title="Supprimer">
        <IconButton
          size="small"
          color="error"
          onClick={() => {
            setIsConfirmationDialogOpen(true);
          }}>
          <DeleteIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Modifier">
        <IconButton
          size="small"
          onClick={() => {
            setIsModificationDialogOpen(true);
          }}>
          <EditIcon color="primary" fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <MetierDialog
        open={isModificationDialogOpen}
        modification
        metier={metier}
        onMetierChanged={onMetierChanged}
        onClose={() => {
          setIsModificationDialogOpen(false);
        }}
      />
      <ConfirmationDialog
        open={isConfirmationDialogOpen}
        onClose={(response) => {
          if (response === "confirm") {
            onMetierDelete(metier);
          }
          setIsConfirmationDialogOpen(false);
        }}
        description="Êtes-vous sûr(e) de vouloir supprimer ce métier ? Cette action est définitive."
        confirmLabel="Oui, supprimer le métier"
      />
    </Grid>
  );
}

export default MetierActions;
